import { render, staticRenderFns } from "./PrintersList.vue?vue&type=template&id=69dcc218&"
import script from "./PrintersList.vue?vue&type=script&lang=js&"
export * from "./PrintersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports